export default __webpack_public_path__ + "media/9373ea917fdb6d600a3ea62b0d28b2119529295490cf23d58d49ba99dad00337.svg";